import {
  Button,
  Drawer,
  Form,
  Image,
  InputNumber,
  Modal,
  Select,
  Space,
  Table,
  Tooltip,
  Typography,
  Input,
} from "antd";
import axios from "axios";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import {
  FileImageOutlined,
  TagOutlined,
  CloseCircleOutlined,
  PrinterOutlined,
  CloseSquareOutlined,
} from "@ant-design/icons";
import {
  NotificationInfo,
  SubscriptionInfo,
  UserInfo,
} from "../../../../context";
import { useReactToPrint } from "react-to-print";
import PrintWith58MMPrinter from "./PrintWith58MMPrinter";
import moment from "moment";
import RFIDTeamLeaderValidation from "./RFIDTeamLeaderValidation";
import VoidSpecProduct from "./VoidSpecProduct";
// import { NotificationInfo, SubscriptionInfo, UserInfo } from "../../../context";

const MerchantEmployeeCheckoutPayLater = ({
  open,
  close,
  setLoading,
  getAllPayLater,
  selectedData,
}) => {
  const componentRef = useRef();
  const [paddingPrint, setPaddingPrint] = useState(0);
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  const scroll = {};
  const [form] = Form.useForm();

  const [voidValidate, setVoidValidate] = useState(false);

  const [orderDetailsList, setOrderDetailsList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const [openConfirmDiag, setOpenConfirmDiag] = useState(false);
  const [totalCost, setTotalCost] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [totalPerProd, setTotalPerProd] = useState(0);
  const [inputtedPayment, setInputtedPayment] = useState(null);
  const [inputtedEcashPayment, setInputtedEcashPayment] = useState(null);
  const [dialogData, setDialogData] = useState(null);
  const [discountDialog, setDiscountDialog] = useState(false);
  const [ePaymentDialog, setEPaymentDialog] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const scaleStep = 0.5;
  const { subscriptionDetails } = useContext(SubscriptionInfo);
  const [selectedMethod, setSelectedMethod] = useState("");
  const [selectedDiscountCat, setSelectedDiscountCat] = useState("");
  const [productDiscount, setProductDiscount] = useState({
    data: [],
    ready: false,
  });
  const [removeSetDiscountDialog, setRemoveSetDiscountDialog] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false); //print
  const [openVoidTransaction, setOpenVoidTransaction] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const tableProps = {
    bordered: false,
    size: "medium",
    showHeader: true,
    scroll,
    tableLayout,
  };

  // const handlePrint = useReactToPrint({
  //   content: () => componentRef.current,

  //   onBeforeGetContent: () => {
  //     return new Promise((resolve) => {
  //       setPaddingPrint(10);
  //       resolve();
  //     });
  //   },
  //   onAfterPrint: () => {
  //     setPaddingPrint(0);
  //   },
  // });

  const columns = [
    {
      title: "Product",
      // dataIndex: "product",
      render: (text) => (
        <p>
          {text.product}
          {parseInt(text.is_per_piece) === 0 && ` - ${text.quantity}gram(s)`}
        </p>
      ),
      // <p>{text}</p>
    },
    {
      title: "Description",
      dataIndex: "description",
      render: (text) => <p>{text}</p>,
    },
    userData.data.usersmerchantemployee.perproductcost !== null && {
      title: userData.data.usersmerchantemployee.perproductcost.description,
      align: "right",
      // dataIndex: "cost_per_prod",
      render: (text) => (
        <p>
          &#8369;{" "}
          {parseFloat(
            parseInt(text.is_per_piece) === 0
              ? text.cost_per_prod
              : text.cost_per_prod * text.quantity
          ).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </p>
      ),
    },
    {
      title: "Price x Quantity",
      align: "right",
      render: (text) => (
        <>
          {parseInt(text.is_per_piece) === 1 ? (
            <p style={{ minWidth: 80, textAlign: "right" }}>
              &#8369;{text.price} x {text.quantity}
            </p>
          ) : (
            <p style={{ minWidth: 80, textAlign: "right" }}>
              &#8369;{text.price}
            </p>
          )}
        </>
        // <p>
        //   &#8369;{text.price} x {text.quantity}
        // </p>
      ),
    },
    {
      title: "Amount",
      align: "right",
      render: (text) => (
        <>
          {parseInt(text.is_per_piece) === 1 ? (
            <p>
              &#8369;{" "}
              {parseFloat(
                parseFloat(text.price) * parseFloat(text.quantity)
              ).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </p>
          ) : (
            <p>
              &#8369;{" "}
              {parseFloat(parseFloat(text.price) * 1).toLocaleString(
                undefined,
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }
              )}
            </p>
          )}
        </>
      ),
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      width: 80,
      render: (text) => (
        <p
          style={{
            width: 80,
            display: text.payment_method === "ecash" ? "none" : "block",
          }}
        >
          {parseInt(text.customerorderroductinfo.allow_discount) === 1 && (
            <>
              {text.discount_category !== null ? (
                <Tooltip title="Remove Discount">
                  <Button
                    type="dashed"
                    shape="circle"
                    onClick={() => {
                      setDialogData(text);
                      setRemoveSetDiscountDialog(true);
                    }}
                    icon={<CloseCircleOutlined />}
                    size="small"
                  />
                </Tooltip>
              ) : (
                <Tooltip title="Discount">
                  <Button
                    type="dashed"
                    shape="circle"
                    onClick={() => {
                      setDialogData(text);
                      setDiscountDialog(true);
                    }}
                    icon={<TagOutlined />}
                    size="small"
                  />
                </Tooltip>
              )}
            </>
          )}

          {text.customerordervariantinfo !== null &&
            parseInt(text.customerordervariantinfo.allow_discount) === 1 && (
              <>
                {text.discount_category !== null ? (
                  <Tooltip title="Remove Discount">
                    <Button
                      type="dashed"
                      shape="circle"
                      onClick={() => {
                        setDialogData(text);
                        setRemoveSetDiscountDialog(true);
                      }}
                      icon={<CloseCircleOutlined />}
                      size="small"
                    />
                  </Tooltip>
                ) : (
                  <Tooltip title="Discount">
                    <Button
                      type="dashed"
                      shape="circle"
                      onClick={() => {
                        setDialogData(text);
                        setDiscountDialog(true);
                      }}
                      icon={<TagOutlined />}
                      size="small"
                    />
                  </Tooltip>
                )}
              </>
            )}

          <Tooltip title="Void">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setDialogData(text);
                setOpenVoidTransaction(true);
                setSelectedProduct(text.product);
                // form2.setFieldsValue({
                //   product: text.product,
                // });
              }}
              style={{ marginLeft: 5 }}
              icon={<CloseSquareOutlined />}
              size="small"
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getMerchantInvoiceDetails = useCallback(() => {
    var params = {
      user_id: userData.data.usersmerchantemployee.merchant_user_id,
      transaction_id: selectedData !== null ? selectedData.transaction_id : "",
      order_category: "products",
    };
    axios
      .get("user/merchant/spec-transaction-info", {
        params,
      })
      .then((response) => {
        const data = response.data;
        // console.log("DATA", data);
        setOrderDetailsList({ data, ready: true });
        setTotalCost(calculateTotal(data));
        setTotalDiscount(calculateDiscount(data));
        setTotalPerProd(calculatePerProdCost(data));
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.usersmerchantemployee.merchant_user_id, selectedData]);

  const getProductDiscount = useCallback(() => {
    var params = {
      user_id: userData.data.usersmerchantemployee.merchant_user_id,
    };
    axios
      .get("user/merchant/discount-list", { params })
      .then((response) => {
        const data = response.data;
        setProductDiscount({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.usersmerchantemployee.merchant_user_id]);

  const calculateTotal = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      // total += parseFloat(data[i].quantity) * parseFloat(data[i].price);
      total +=
        parseInt(data[i].is_per_piece) === 1
          ? parseFloat(data[i].quantity) *
            parseFloat(data[i].price.replace(",", ""))
          : parseFloat(data[i].price.replace(",", ""));
    }
    return total;
  };

  const calculateDiscount = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total += parseFloat(data[i].discount_amount) * 1;
    }
    return total;
  };

  const calculatePerProdCost = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total +=
        parseFloat(
          data[i].cost_per_prod !== null
            ? parseInt(data[i].is_per_piece) === 0
              ? data[i].cost_per_prod
              : data[i].cost_per_prod * data[i].quantity
            : 0
        ) * 1;
    }
    return total;
  };

  const handleClearTransaction = (values) => {
    const formdata = new FormData();
    formdata.append(
      "user_id",
      userData.data.usersmerchantemployee.merchant_user_id
    );
    formdata.append(
      "merchant_uid",
      userData.data.usersmerchantemployee.merchant_uid
    );
    formdata.append(
      "total_cost",
      parseFloat(totalCost + totalPerProd - totalDiscount)
    );
    formdata.append(
      "transaction_id",
      selectedData !== null ? selectedData.transaction_id : ""
    );
    formdata.append(
      "allow_inventory",
      subscriptionDetails.data.subsmerchantfeat.enable_inventory_report
    );
    formdata.append("account", "cashier");
    formdata.append("cashier_by", userData.data.id);

    for (const name in values) {
      formdata.append(name, values[name]);
    }
    var error = [];
    var cashpayment = parseFloat(
      inputtedPayment !== null ? inputtedPayment : 0
    );
    var ecashpayment = parseFloat(
      inputtedEcashPayment !== null ? inputtedEcashPayment : 0
    );
    if (
      selectedMethod !== "pay-later" &&
      selectedMethod !== "confirm-only" &&
      parseFloat(cashpayment + ecashpayment) <
        parseFloat(totalCost + totalPerProd - totalDiscount)
    ) {
      error = "error";
    }
    if (error.length > 0) {
      rerunNotif("error", "Payment input invalid.");
    } else {
      setLoadings(true);
      setLoading(true);
      axios
        .post("user/merchant/confirm-payment", formdata)
        .then((response) => {
          const data = response.data;
          if (data === "success") {
            rerunNotif("success", "Confirm payment successfully.");
            setTimeout(() => {
              // close();
              setOpenDrawer(true);
              setLoadings(false);
              setLoading(false);
              setOpenConfirmDiag(false);
              getAllPayLater();
            }, 1000);
          }
        })
        .catch((error) => {
          setLoadings(false);
        });
    }
  };

  useEffect(() => {
    getMerchantInvoiceDetails();
    getProductDiscount();
  }, [getMerchantInvoiceDetails, getProductDiscount]);

  const handleEPaymentOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setEPaymentDialog(false);
      setConfirmLoading(false);
      handleConfirmEPaymentAsPaid();
    }, 2000);
  };

  const handleRemoveSetDiscountOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setRemoveSetDiscountDialog(false);
      setConfirmLoading(false);
      handleConfirmRemoveSetDiscount();
    }, 2000);
  };

  const handleConfirmEPaymentAsPaid = () => {
    const formdata = new FormData();
    formdata.append(
      "user_id",
      userData.data.usersmerchantemployee.merchant_user_id
    );
    formdata.append(
      "merchant_uid",
      userData.data.usersmerchantemployee.merchant_uid
    );

    formdata.append("payment", totalCost + totalPerProd - totalDiscount);
    formdata.append(
      "transaction_id",
      selectedData !== null ? selectedData.transaction_id : ""
    );
    formdata.append(
      "allow_inventory",
      subscriptionDetails.data.subsmerchantfeat.enable_inventory_report
    );

    setLoadings(true);
    axios
      .post("user/merchant/confirm-epayment", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Confirm payment as paid successfully.");
          setTimeout(() => {
            close();
            setLoadings(false);
            setLoading(false);
            getAllPayLater();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  const handleConfirmRemoveSetDiscount = () => {
    const formdata = new FormData();
    formdata.append(
      "user_id",
      userData.data.usersmerchantemployee.merchant_user_id
    );
    formdata.append("id", dialogData !== null ? dialogData.id : "");

    setLoadings(true);
    axios
      .post("user/merchant/remove-set-discount", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Confirm remove setted discount successfully.");
          setTimeout(() => {
            setLoadings(false);
            setLoading(false);
            getMerchantInvoiceDetails();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  const handleSetSpecDiscount = (values) => {
    const formdata = new FormData();

    var percentagedena = parseFloat(values.discount_percentage) / 100;
    var percentagevalue =
      parseFloat(dialogData !== null && dialogData.price) *
      parseFloat(percentagedena);

    var finaldisamount =
      selectedDiscountCat === "amount"
        ? parseFloat(values.discount_amount) *
          parseFloat(values.discount_quantity)
        : parseFloat(percentagevalue) * parseFloat(values.discount_quantity);

    formdata.append(
      "user_id",
      userData.data.usersmerchantemployee.merchant_user_id
    );
    formdata.append("id", dialogData !== null && dialogData.id);
    formdata.append("finaldisamount", finaldisamount);
    for (const name in values) {
      formdata.append(name, values[name]);
    }

    setLoadings(true);
    axios
      .post("user/merchant/set-spec-discount", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Spec discount added successfully.");
          setTimeout(() => {
            setDiscountDialog(false);
            setLoadings(false);
            getMerchantInvoiceDetails();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  return (
    <Drawer
      title="Order Details"
      width={window.innerWidth > 800 ? 800 : "100vw"}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
      extra={
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{ flexGrow: 1 }} />
          {/* <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => setAddProductToOrder(true)}
              style={{
                display:
                  orderDetailsList.ready &&
                  orderDetailsList.data[0].payment_method === "ecash"
                    ? "none"
                    : "block",
              }}
            >
              Product
            </Button> */}

          <Button
            type="primary"
            icon={<FileImageOutlined />}
            onClick={() => setVisible(true)}
            style={{
              display:
                orderDetailsList.ready &&
                orderDetailsList.data[0].payment_method === "ecash"
                  ? "block"
                  : "none",
            }}
          >
            View Attachment
          </Button>

          {/* <Button
            type="primary"
            icon={<PrinterOutlined />}
            // onClick={() => setVisible(true)}
            // style={{
            //   display:
            //     orderDetailsList.ready &&
            //     orderDetailsList.data[0].payment_method === "ecash"
            //       ? "block"
            //       : "none",
            // }}
            // onClick={handlePrint}
            onClick={() => setOpenDrawer(true)}
          >
            Print
          </Button> */}
        </div>
      }
    >
      {selectedData !== null && (
        <>
          {orderDetailsList.ready &&
            orderDetailsList.data[0].payment_method === "ecash" && (
              <div>
                <Image
                  width={200}
                  style={{
                    display: "none",
                  }}
                  src=""
                  preview={{
                    visible,
                    scaleStep,
                    src: `${import.meta.env.VITE_API_IMAGE}payment/${
                      orderDetailsList.data[0].payment_attachment
                    }`,
                    onVisibleChange: (value) => {
                      setVisible(value);
                    },
                  }}
                  alt="payment-img"
                />
              </div>
            )}

          <div
            style={{ overflowX: "auto", padding: paddingPrint }}
            ref={componentRef}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography style={{ fontSize: 14 }}>
                Customer Name:{" "}
                <span
                  style={{ fontWeight: "bold", textTransform: "capitalize" }}
                >
                  {orderDetailsList.ready &&
                    orderDetailsList.data[0].customer_name}
                </span>
              </Typography>

              <Typography
                style={{
                  fontSize: 14,
                  display:
                    orderDetailsList.ready &&
                    orderDetailsList.data[0].table_no !== "Table #"
                      ? "block"
                      : "none",
                }}
              >
                Location:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {orderDetailsList.ready && orderDetailsList.data[0].table_no}
                </span>
              </Typography>

              <Typography
                style={{
                  fontSize: 14,
                  display:
                    orderDetailsList.ready &&
                    orderDetailsList.data[0].contact_no !== null
                      ? "block"
                      : "none",
                }}
              >
                Customer #:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {orderDetailsList.ready &&
                    orderDetailsList.data[0].contact_no}
                </span>
              </Typography>

              <Typography
                style={{
                  fontSize: 14,
                  display:
                    orderDetailsList.ready &&
                    orderDetailsList.data[0].customer_address !== null
                      ? "block"
                      : "none",
                }}
              >
                Customer Address:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {orderDetailsList.ready &&
                    orderDetailsList.data[0].customer_address}
                </span>
              </Typography>

              <Typography
                style={{
                  fontSize: 14,
                  textTransform: "capitalize",
                }}
              >
                Status:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {orderDetailsList.ready &&
                    orderDetailsList.data[0].service_category}
                </span>
              </Typography>
              <Typography
                style={{
                  fontSize: 14,
                  textTransform: "capitalize",
                  marginBottom: 10,
                }}
              >
                Transaction #:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {orderDetailsList.ready &&
                    orderDetailsList.data[0].transaction_id}
                </span>
              </Typography>
            </div>

            <Table
              {...tableProps}
              pagination={false}
              columns={tableColumns}
              dataSource={
                orderDetailsList.data.length > 0 ? orderDetailsList.data : []
              }
              scroll={scroll}
              rowKey={(record) => record.id}
              expandable={{
                expandedRowRender: (record) => (
                  <p style={{ margin: 0 }}>
                    Discount by{" "}
                    {record.discount_category === "percentage"
                      ? `(${record.price} * ${record.discount_percentage}%) * ${record.discount_quantity} = ${record.discount_amount}`
                      : `${record.discount_amount}`}
                  </p>
                ),
                rowExpandable: (record) => record.discount_category !== null,
              }}
            />
            <div style={{ display: "flex", padding: 15 }}>
              <div style={{ flexGrow: 1 }} />
              <div>
                <Typography
                  style={{
                    fontWeight: "bold",
                    fontSize: 16,
                    textAlign: "right",
                  }}
                >
                  Total Product: &#8369;
                  {totalCost.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </Typography>
                {userData.data.usersmerchantemployee.perproductcost !==
                  null && (
                  <Typography
                    style={{
                      fontWeight: "bold",
                      fontSize: 16,
                      textAlign: "right",
                    }}
                  >
                    Total{" "}
                    {
                      userData.data.usersmerchantemployee.perproductcost
                        .description
                    }
                    : &#8369;
                    {totalPerProd.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </Typography>
                )}
                {totalDiscount > 0 && (
                  <Typography
                    style={{
                      fontWeight: "bold",
                      fontSize: 16,
                      textAlign: "right",
                    }}
                  >
                    Discount: &#8369;
                    {totalDiscount.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </Typography>
                )}
                <Typography
                  style={{
                    fontWeight: "bold",
                    fontSize: 16,
                    textAlign: "right",
                  }}
                >
                  Grand Total: &#8369;
                  {parseFloat(
                    totalCost + totalPerProd - totalDiscount
                  ).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </Typography>
              </div>
            </div>
          </div>
        </>
      )}

      <Button
        type="primary"
        loading={loadings}
        style={{ width: "100%", borderRadius: "20px" }}
        onClick={() => {
          if (
            orderDetailsList.ready &&
            orderDetailsList.data[0].payment_method === "ecash"
          ) {
            setEPaymentDialog(true);
          } else {
            setOpenConfirmDiag(true);
          }
        }}
      >
        {!loadings
          ? orderDetailsList.ready &&
            orderDetailsList.data[0].payment_method === "ecash"
            ? "Confirm Payment"
            : "Checkout"
          : "Loading"}
      </Button>

      <Modal
        title=""
        open={openConfirmDiag}
        onCancel={() => setOpenConfirmDiag(false)}
        footer={null}
        centered
      >
        <Form
          layout="vertical"
          name="merchant-payment-confirm7"
          initialValues={{
            total_cost: totalCost + totalPerProd - totalDiscount,
          }}
          onFinish={handleClearTransaction}
          autoComplete="off"
          form={form}
        >
          <Space
            direction="vertical"
            style={{ width: "100%", margin: 0, marginTop: 20 }}
          >
            <div
              style={{
                marginTop: 20,
                marginBottom: 5,
              }}
            >
              <Typography>Total Cost</Typography>
            </div>

            <div
              style={{
                border: "1px solid #e5e5e5",

                marginBottom: 20,
                padding: 10,
                borderRadius: 10,
              }}
            >
              {parseFloat(
                totalCost + totalPerProd - totalDiscount
              ).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </div>

            <Form.Item
              name="method"
              label="Method"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select
                placeholder="Select method"
                onChange={(e) => {
                  setSelectedMethod(e);
                  setInputtedPayment(null);
                  setInputtedEcashPayment(null);
                  form.setFieldsValue({
                    noncash: null,
                    customer_payment: null,
                    customer_epayment: null,
                    e_ref_no: null,
                  });
                }}
                size="large"
                showSearch
              >
                <Select.Option value={"confirm-only"}>
                  Confirm Only
                </Select.Option>
                <Select.Option value={"enter-payment"}>
                  Confirm w/ Cash Payment
                </Select.Option>
                {/* NEW FUNCTION`` */}
                <Select.Option value={"ecash-payment"}>
                  Confirm w/ ECash Payment
                </Select.Option>
                <Select.Option value={"split-payment"}>
                  Split Payment
                </Select.Option>
                {/* <Select.Option value={"pay-later"}>Pay Later</Select.Option> */}
              </Select>
            </Form.Item>

            {selectedMethod === "enter-payment" && (
              <Form.Item
                name="customer_payment"
                label="Cash Payment"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <InputNumber
                  min={1}
                  max={999999999999}
                  initialvalues={0}
                  size="large"
                  style={{ width: "100%" }}
                  step="0.01"
                  onChange={(value) => {
                    setInputtedPayment(value);
                  }}
                />
              </Form.Item>
            )}

            {selectedMethod === "ecash-payment" && (
              <>
                <Form.Item
                  name="noncash"
                  label="Non-cash"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select non-cash"
                    onChange={(e) => {
                      // setSelectedMethod(e);
                      setInputtedPayment(null);
                      setInputtedEcashPayment(null);
                      form.setFieldsValue({
                        customer_payment: null,
                        customer_epayment: null,
                        e_ref_no: null,
                      });
                    }}
                    size="large"
                    showSearch
                  >
                    <Select.Option value={"gcash"}>GCash</Select.Option>
                    <Select.Option value={"gcredit"}>GCredit</Select.Option>
                    <Select.Option value={"paymaya"}>Paymaya</Select.Option>
                    <Select.Option value={"creditcard"}>
                      Credit Card
                    </Select.Option>
                    <Select.Option value={"debitcard"}>
                      Debit Card
                    </Select.Option>
                    <Select.Option value={"banktransfer"}>
                      Bank Transfer
                    </Select.Option>
                    <Select.Option value={"cheque"}>Cheque</Select.Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  name="customer_epayment"
                  label="ECash Payment"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={1}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="0.01"
                    onChange={(value) => setInputtedEcashPayment(value)}
                  />
                </Form.Item>
                <Form.Item
                  name="e_ref_no"
                  label="Reference #"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <Input placeholder="Set ref no" size="large" />
                </Form.Item>
              </>
            )}

            {selectedMethod === "split-payment" && (
              <>
                <Form.Item
                  name="customer_payment"
                  label="Cash Payment"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={1}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="0.01"
                    onChange={(value) => setInputtedPayment(value)}
                  />
                </Form.Item>

                <Form.Item
                  name="noncash"
                  label="Non-cash"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select non-cash"
                    onChange={(e) => {
                      // setSelectedMethod(e);
                      setInputtedPayment(null);
                      setInputtedEcashPayment(null);
                      form.setFieldsValue({
                        customer_payment: null,
                        customer_epayment: null,
                        e_ref_no: null,
                      });
                    }}
                    size="large"
                    showSearch
                  >
                    <Select.Option value={"gcash"}>GCash</Select.Option>
                    <Select.Option value={"gcredit"}>GCredit</Select.Option>
                    <Select.Option value={"paymaya"}>Paymaya</Select.Option>
                    <Select.Option value={"creditcard"}>
                      Credit Card
                    </Select.Option>
                    <Select.Option value={"debitcard"}>
                      Debit Card
                    </Select.Option>
                    <Select.Option value={"banktransfer"}>
                      Bank Transfer
                    </Select.Option>
                    <Select.Option value={"cheque"}>Cheque</Select.Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  name="customer_epayment"
                  label="ECash Payment"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={1}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="0.01"
                    onChange={(value) => setInputtedEcashPayment(value)}
                  />
                </Form.Item>
                <Form.Item
                  name="e_ref_no"
                  label="Reference #"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <Input placeholder="Set ref no" size="large" />
                </Form.Item>
              </>
            )}

            {selectedMethod === "enter-payment" ? (
              <>
                {inputtedPayment !== null && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      border: "1px solid green",
                    }}
                  >
                    <Typography style={{ fontSize: 22, fontWeight: "bold" }}>
                      &#8369;
                      {parseFloat(
                        parseFloat(inputtedPayment) -
                          parseFloat(totalCost + totalPerProd - totalDiscount)
                      ).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </Typography>
                    <Typography style={{ color: "green", fontWeight: "bold" }}>
                      Change
                    </Typography>
                  </div>
                )}
              </>
            ) : null}
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              loading={loadings}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
            >
              {loadings ? "Loading" : "Confirm"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title=""
        open={discountDialog}
        onCancel={() => {
          setDiscountDialog(false);
          setVoidValidate(false);
        }}
        footer={null}
        width={350}
        centered
        getContainer={false}
      >
        {voidValidate && (
          <Form
            layout="vertical"
            name="add-discount-spec-order6"
            initialValues={{
              total_cost: totalCost + totalPerProd - totalDiscount,
            }}
            onFinish={handleSetSpecDiscount}
            autoComplete="off"
          >
            <Space
              direction="vertical"
              style={{ width: "100%", margin: 0, marginTop: 20 }}
            >
              <Form.Item
                name="discount_category"
                label="Discount Category"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <Select
                  placeholder="-"
                  onChange={(e) => {
                    setSelectedDiscountCat(e);
                  }}
                  size="large"
                  showSearch
                >
                  <Select.Option value={"amount"}>Amount</Select.Option>
                  <Select.Option value={"percentage"}>Percentage</Select.Option>
                </Select>
              </Form.Item>

              <Form.Item
                name="discount_quantity"
                label="Discount Quantity"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <InputNumber
                  min={1}
                  max={dialogData !== null && dialogData.quantity}
                  initialvalues={1}
                  size="large"
                  style={{ width: "100%" }}
                  step="1"
                />
              </Form.Item>

              {selectedDiscountCat === "amount" && dialogData !== null && (
                <Form.Item
                  name="discount_amount"
                  label="Discount Amount"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={1}
                    max={
                      parseFloat(dialogData.price) *
                      parseFloat(dialogData.quantity)
                    }
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="0.01"
                  />
                </Form.Item>
              )}

              {selectedDiscountCat === "percentage" &&
                productDiscount.ready && (
                  <Form.Item
                    name="discount_percentage"
                    label="Discount Percentage"
                    rules={[
                      {
                        required: true,
                        message: "Required",
                      },
                    ]}
                  >
                    <Select placeholder="-" size="large" showSearch>
                      {productDiscount.data.length > 0 &&
                        productDiscount.data.map((data, index) => (
                          <Select.Option value={data.percentage} key={index}>
                            {data.description} - {data.percentage}%
                          </Select.Option>
                        ))}
                    </Select>
                  </Form.Item>
                )}
            </Space>

            <Form.Item style={{ marginTop: "20px" }}>
              <Button
                type="primary"
                loading={loadings}
                htmlType="submit"
                style={{ width: "100%", borderRadius: "20px" }}
              >
                {loadings ? "Loading" : "Set Discount"}
              </Button>
            </Form.Item>
          </Form>
        )}

        {!voidValidate && (
          <RFIDTeamLeaderValidation setVoidValidate={setVoidValidate} />
        )}
      </Modal>

      <Modal
        title="Are you sure to confirm this transaction as paid?"
        open={ePaymentDialog}
        onOk={handleEPaymentOk}
        confirmLoading={confirmLoading}
        onCancel={() => setEPaymentDialog(false)}
        centered
      />

      <Modal
        title="Are you sure to remove the setted discount?"
        open={removeSetDiscountDialog}
        onOk={handleRemoveSetDiscountOk}
        confirmLoading={confirmLoading}
        onCancel={() => setRemoveSetDiscountDialog(false)}
        centered
      />

      <Modal
        title=""
        open={openVoidTransaction}
        onCancel={() => {
          setOpenVoidTransaction(false);
          setVoidValidate(false);
        }}
        footer={null}
        width={350}
        centered
        getContainer={false}
      >
        {voidValidate && (
          <>
            <div style={{ marginBottom: 10, marginTop: 10 }}>
              <Typography style={{ fontSize: 20, fontWeight: "bold" }}>
                Void Specific Product
              </Typography>
            </div>

            {dialogData !== null && (
              <VoidSpecProduct
                // form2={form2}
                dialogData={dialogData}
                getMerchantInvoiceDetails={() => getMerchantInvoiceDetails()}
                selectedProduct={selectedProduct}
                orderlength={
                  orderDetailsList.ready && orderDetailsList.data.length
                }
                close={() => {
                  close();
                  getAllPayLater();
                }}
                closeDiag={() => {
                  setOpenVoidTransaction(false);
                  setVoidValidate(false);
                }}
              />
            )}
          </>
        )}
        {!voidValidate && (
          <RFIDTeamLeaderValidation setVoidValidate={setVoidValidate} />
        )}
      </Modal>

      {/* {console.log("orderDetailsList: ", orderDetailsList)} */}

      {openDrawer && (
        <PrintWith58MMPrinter
          open={openDrawer}
          close={() => {
            setOpenDrawer(false);
            close();
          }}
          data={orderDetailsList.ready && orderDetailsList.data}
          totalCost={totalCost}
          totalDiscount={totalDiscount}
          totalPerProd={totalPerProd}
          description={
            userData.data.usersmerchantemployee.perproductcost !== null &&
            userData.data.usersmerchantemployee.perproductcost.description
          }
          hasCostPerProd={
            userData.data.usersmerchantemployee.perproductcost !== null
          }
          //   productList={productList}
        />
      )}
    </Drawer>
  );
};

export default MerchantEmployeeCheckoutPayLater;
